import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {PointModel} from "../models/point.model";
import {PerfectScrollbarComponent} from "ngx-perfect-scrollbar";
import {GoogleMapsService} from "../services/googleMaps.service";
import {AngularFirestore} from "angularfire2/firestore";
import {FavouriteType} from "../types/favourite.type";
import {AppModeEnum} from "../enums/appMode.enum";
import {UserFavourites} from "../models/userFavourites.model";

@Component({
  selector: 'points-list',
  templateUrl: './points-list.component.html',
  styleUrls: ['./points-list.component.scss']
})
export class PointsListComponent implements OnInit, OnChanges {

  @ViewChild('perfectScrollbar') perfectScrollbar: PerfectScrollbarComponent;
  @Input() appMode: AppModeEnum;
  @Input() points: PointModel[];
  @Input() currentCoordinates: PointModel;
  @Input() selectedPoint: PointModel;
  @Input() userFavourites: UserFavourites;
  @Input() isFavourite: void;
  @Output() selectedPointChange: EventEmitter<PointModel> = new EventEmitter<PointModel>();
  @Output() drawDirection: EventEmitter<PointModel> = new EventEmitter<PointModel>();

  public user: any;

  constructor( public googleMapsService: GoogleMapsService, private db: AngularFirestore ) {
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('RandomRideUserInfo'));
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.selectedPoint){
      this.scrollToSelectedPoint();
    }
  }

  public selectPoint(point, $event?){
    $event && $event.stopPropagation();
    // if(point === this.selectedPoint) {
    //   point = null;
    // }
    this.selectedPointChange.emit(point);
  }

  public scrollToSelectedPoint(){
    setTimeout(()=>{
      let querySelector = '#pointsListPerfectScrollbar li.active';
      this.perfectScrollbar.directiveRef.scrollToElement(querySelector, 0, 300);
    }, 10);
  }

  public drawDirectionToPoint(point, $event){
    $event.stopPropagation();
    this.selectPoint(point);
    this.drawDirection.emit(point);
  }

  public toggleFavourites(point, parentPoint, currentState, $event){
    $event.stopPropagation();
    let isCustomPoint = this.appMode === AppModeEnum.discover;
    if(currentState){
      this.removeFromFavourites(point, parentPoint, isCustomPoint);
    } else {
      this.addToFavourites(point, parentPoint, isCustomPoint);
    }
  }

  public addToFavourites(point, parentPoint, custom?: boolean){
    let pointId = point.uid || this.db.createId();
    let pointData: FavouriteType = {};
    pointData.uid = pointId;
    if(custom){
      pointData.favouriteType = AppModeEnum[AppModeEnum.discover];
      pointData.lat = point.lat;
      pointData.lng = point.lng;
    } else {
      pointData.favouriteType = AppModeEnum[this.appMode as number];
    }
    if(parentPoint){
      pointData.parentUid = parentPoint.uid;
    }

    this.db.collection('users/'+this.user.fbId+'/favourites').doc(pointId).set(pointData).then(res => {
    });
  }

  public removeFromFavourites(point, parentPoint, customPoint?: boolean){
    console.log('removeFromFavourites', arguments);
    let uid;
    if (point.uid){
      uid = point.uid;
    } else {
      this.userFavourites.discover.some( p => {
        if (p.lat === point.lat && p.lng === point.lng){
          uid = p.uid;
          return true;
        }
      });
    }
    this.db.collection('users/'+this.user.fbId+'/favourites').doc(uid).delete().then(res => {

    });
  }

  public exportPoi(){
    this.points.forEach(point => {
      let children = point.children;
      let onlyPoint = point;
      delete onlyPoint.children;
      onlyPoint.uid = this.db.createId();
        this.db.collection('poi').doc(onlyPoint.uid).set(onlyPoint).then(res => {
        children.forEach(child => {
          let onlyChild = child;
          delete onlyChild.children;
          onlyChild.uid = this.db.createId();
          onlyChild.parentUid = onlyPoint.uid;
          this.db.collection('poi/' + onlyPoint.uid + '/children').doc(onlyChild.uid).set(onlyChild);
        })
      });
    })
  }

  public distanceComparator(itemA, itemB) {
    return +itemA > +itemB ? 1 : -1;
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/points-list/points-list.component.ts